const ABSOLUTE_PATH = import.meta.env.VITE_NX_USE_ABSOLUTE_PATH || "";


export * from './actionTypes';
export { ABSOLUTE_PATH };